<div class="page-title-area page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>{{'MENU.CONGRATS' | translate}}</h2>
                <ul>
                    <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>{{'MENU.CONGRATS' | translate}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="isLoading$ | async">
    <div class="progress progress-modal">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
            style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</ng-container>
<!-- <div class="doctor-search-area">
    <div class="container">
        <form>
            <div class="row doctor-search-wrap">
                <div class="col-sm-3 col-lg-3"></div>
                <div class="col-sm-6 col-lg-6">
                    <div class="doctor-search-item">
                        <div class="form-group">
                            <i class="icofont-ui-image"></i>
                            <label>{{ language == 'en'? 'Category':
                                'الفئة' }}</label>
                            <select class="form-control" (change)="OnChangeCongratsCategory($event)"
                                *ngIf="CongratsCategories$ | async as CongratsCategories ;else EmptyCongratsCategories">
                                <option value="">{{'COMMON.SELECT' | translate}}</option>
                                <option value={{CongratsCategory.id}}
                                    *ngFor="let CongratsCategory of CongratsCategories">{{ language == 'en'?
                                    CongratsCategory.nameEn: CongratsCategory.nameAr }}</option>
                            </select>
                            <ng-template #EmptyCongratsCategories>
                                <select class="form-control">
                                    <option value="">{{'COMMON.SELECT' | translate}}</option>
                                </select>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div> -->
<section class="blog-area-two pt-100">
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-lg-2"></div>

            <div  class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                <div class="blog-item">
                    <div class="blog-top blog-top-congrats">
                        <a (click)="openDialog('assets/img/congrats/1.jpeg')"><img src="assets/img/congrats/1.jpeg" alt="CongratImage"></a>
                    </div>
                </div>
            </div>
            <div  class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                <div class="blog-item">
                    <div class="blog-top blog-top-congrats">
                        <a (click)="openDialog('assets/img/congrats/2.jpeg')"><img src="assets/img/congrats/2.jpeg" alt="CongratImage"></a>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-2"></div>

            <!-- <div *ngFor="let CongratsImage of CongratsImages"
                class="col-sm-6 col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                <div class="blog-item">
                    <div class="blog-top">
                        <a *ngIf="CongratsImage.imagePath != null;else CongratImage"
                            (click)="openDialog(CongratsImage)"><img [src]="CongratsImage.imagePath | SafeUrlPipe"
                                alt="CongratImage"></a>
                        <ng-template #CongratImage><a><img src="assets/img/DefaultImage.png" alt="CongratImage"
                                    height="250px" width="350px"></a></ng-template>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</section>